import { useRef, useCallback } from 'react';

const BOARD_FILL_PATH = '/audio/board-fill.mp3';
const DAILY_DOUBLE_PATH = '/audio/daily-double.mp3';
const RIGHT_ANSWER_PATH = '/audio/right-answer.mp3';
const TIMES_UP_PATH = '/audio/times-up.mp3';

export const useGameSounds = () => {
  const boardFillAudioRef = useRef<HTMLAudioElement | null>(null);
  const dailyDoubleAudioRef = useRef<HTMLAudioElement | null>(null);
  const rightAnswerAudioRef = useRef<HTMLAudioElement | null>(null);
  const timesUpAudioRef = useRef<HTMLAudioElement | null>(null);

  // Initialize audio elements
  const initAudio = useCallback((ref: React.MutableRefObject<HTMLAudioElement | null>, path: string) => {
    if (!ref.current) {
      const audio = new Audio(path);
      audio.volume = 0.7;
      ref.current = audio;
    }
    return ref.current;
  }, []);

  const playBoardFill = useCallback(() => {
    const audio = initAudio(boardFillAudioRef, BOARD_FILL_PATH);
    audio.currentTime = 0;
    audio.play().catch(console.error);
  }, [initAudio]);

  const playDailyDouble = useCallback(() => {
    const audio = initAudio(dailyDoubleAudioRef, DAILY_DOUBLE_PATH);
    audio.currentTime = 0;
    audio.play().catch(console.error);
  }, [initAudio]);

  const playRightAnswer = useCallback(() => {
    const audio = initAudio(rightAnswerAudioRef, RIGHT_ANSWER_PATH);
    audio.currentTime = 0;
    audio.play().catch(console.error);
  }, [initAudio]);

  const playTimesUp = useCallback(() => {
    const audio = initAudio(timesUpAudioRef, TIMES_UP_PATH);
    audio.currentTime = 0;
    audio.play().catch(console.error);
  }, [initAudio]);

  return {
    playBoardFill,
    playDailyDouble,
    playRightAnswer,
    playTimesUp,
  };
};



